import { AxiosError } from "axios";
import { createApi } from "../../../utils/createApi";
import { markSiteUnsynced } from "../../../utils/syncStore";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import ErrorBoundary from "../../../../ErrorBoundary";
import { NavigateFunction } from "react-router-dom";
import { AlertSettingsTab } from "../AlertSettingsTab";
import { useEditCameraStore } from "../editCameraStore/editCameraStore";

export const handleDeleteDiceAlert = (
  diceAlertId: number,
  diceAlerts: any,
  setDiceAlerts: any,
  setActiveTab: any,
  setAddDiceAlertDialogOpen: any,
  setSendingDiceTest: Dispatcher<boolean>,
  setDiceTestSuccessDialogOpen: Dispatcher<boolean>,
  setDiceTestFailDialogOpen: Dispatcher<boolean>,
  setDeleteDiceAlertDialogOpen: Dispatcher<boolean>,
  setBackdropLoadingScreenOn: any,
  sureviewAlerts: any,
  setAddSureviewAlertDialogOpen: any,
  cameraWebhookData: any,
  setAddStreamWebhookDialogOpen: any,
  setEditStreamWebhookDialogOpen: any,
  sentinelAlerts: any,
  setAddSentinelAlertDialogOpen: any,
  boldAlerts: any,
  setAddBoldAlertDialogOpen: any,
  patriotAlerts: any,
  setAddPatriotAlertDialogOpen: any,
  softguardAlerts: any,
  setAddSoftguardAlertDialogOpen: any,
  diceAlertsOnCamera: any,
  sureViewAlertsOnCamera: any,
  siteInfo: any,
  webhooksAlertsOnCamera: any,
  sentinelAlertsOnCamera: any,
  boldAlertsOnCamera: any,
  patriotAlertsOnCamera: any,
  softguardAlertsOnCamera: any,
  evalinkAlertsOnCamera: boolean,
  navigate: NavigateFunction
) => {
  const AxiosUI = createApi(``);

  const retryFunction = () => {
    handleDeleteDiceAlert(
      diceAlertId,
      diceAlerts,
      setDiceAlerts,
      setActiveTab,
      setAddDiceAlertDialogOpen,
      setSendingDiceTest,
      setDiceTestSuccessDialogOpen,
      setDiceTestFailDialogOpen,
      setDeleteDiceAlertDialogOpen,
      setBackdropLoadingScreenOn,
      sureviewAlerts,
      setAddSureviewAlertDialogOpen,
      cameraWebhookData,
      setAddStreamWebhookDialogOpen,
      setEditStreamWebhookDialogOpen,
      sentinelAlerts,
      setAddSentinelAlertDialogOpen,
      boldAlerts,
      setAddBoldAlertDialogOpen,
      patriotAlerts,
      setAddPatriotAlertDialogOpen,
      softguardAlerts,
      setAddSoftguardAlertDialogOpen,
      diceAlertsOnCamera,
      sureViewAlertsOnCamera,
      siteInfo,
      webhooksAlertsOnCamera,
      sentinelAlertsOnCamera,
      boldAlertsOnCamera,
      patriotAlertsOnCamera,
      softguardAlertsOnCamera,
      evalinkAlertsOnCamera,
      navigate
    );
  };

  const {
    cameraStreamsObject,
    setCameraStreamsPatchObject,
    setCameraStreamsObject,
    cameraStreamsSelectedIndex,
  } = useEditCameraStore.getState();

  AxiosUI.delete(`/dice/${diceAlertId}/`).then(
    () => {
      // Alert configs ride settings.json — deleting one needs a sync.
      markSiteUnsynced();
      // const updatedDiceAlerts = diceAlerts.filter(
      //   (alert: any) => Number(alert.id) !== Number(diceAlertId)
      // );

      const updatedStreams = cameraStreamsObject;

      if (
        updatedStreams[cameraStreamsSelectedIndex]?.dice_alerts &&
        cameraStreamsObject[cameraStreamsSelectedIndex]?.dice_alerts
      ) {
        updatedStreams[cameraStreamsSelectedIndex]!.dice_alerts =
          cameraStreamsObject[cameraStreamsSelectedIndex]!.dice_alerts!.filter(
            (alert: any) => Number(alert.id) !== Number(diceAlertId)
          );
      }

      setCameraStreamsPatchObject(updatedStreams);
      setCameraStreamsObject(updatedStreams);

      // setDiceAlerts(updatedDiceAlerts);
      setActiveTab(<></>);
      setActiveTab(
        <ErrorBoundary>
          <AlertSettingsTab
            diceAlerts={[]}
            setAddDiceAlertDialogOpen={setAddDiceAlertDialogOpen}
            setSendingDiceTest={setSendingDiceTest}
            setDiceTestSuccessDialogOpen={setDiceTestSuccessDialogOpen}
            setDiceTestFailDialogOpen={setDiceTestFailDialogOpen}
            setDeleteDiceAlertDialogOpen={setDeleteDiceAlertDialogOpen}
            sureviewAlerts={sureviewAlerts}
            setAddSureviewAlertDialogOpen={setAddSureviewAlertDialogOpen}
            setAddStreamWebhookDialogOpen={setAddStreamWebhookDialogOpen}
            setEditStreamWebhookDialogOpen={setEditStreamWebhookDialogOpen}
            sentinelAlerts={sentinelAlerts}
            setAddSentinelAlertDialogOpen={setAddSentinelAlertDialogOpen}
            boldAlerts={boldAlerts}
            setAddBoldAlertDialogOpen={setAddBoldAlertDialogOpen}
            patriotAlerts={patriotAlerts}
            setAddPatriotAlertDialogOpen={setAddPatriotAlertDialogOpen}
            softguardAlerts={softguardAlerts}
            setAddSoftguardAlertDialogOpen={setAddSoftguardAlertDialogOpen}
            diceAlertsOnCamera={diceAlertsOnCamera}
            sureViewAlertsOnCamera={sureViewAlertsOnCamera}
            siteInfo={siteInfo}
            webhooksAlertsOnCamera={webhooksAlertsOnCamera}
            sentinelAlertsOnCamera={sentinelAlertsOnCamera}
            boldAlertsOnCamera={boldAlertsOnCamera}
            patriotAlertsOnCamera={patriotAlertsOnCamera}
            softguardAlertsOnCamera={softguardAlertsOnCamera}
            evalinkAlertsOnCamera={evalinkAlertsOnCamera}
            navigate={navigate}
          />
        </ErrorBoundary>
      );
      setBackdropLoadingScreenOn(false);
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        alert("Error deleting Dice Alert, please try again.");
        setBackdropLoadingScreenOn(false);
      });
    }
  );
};
